/* Remember only explicitly chosen products. Never initiate payment or automatic cart additions. */
(() => {
  const key = 'jr-pantry-selection-v1';
  const root = window.Shopify?.routes?.root || '/';
  const read = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(key));
      if (!saved || Date.now() - saved.at > 7 * 86400000 || !Array.isArray(saved.items)) return [];
      return saved.items.filter(x => /^\d+$/.test(String(x.id)) && /^[a-z0-9-]+$/.test(x.handle)).slice(0, 6);
    } catch { return []; }
  };
  const clear = () => { try { localStorage.removeItem(key); } catch {} };
  const save = items => { try { localStorage.setItem(key, JSON.stringify({at:Date.now(),items})); } catch {} };
  document.querySelectorAll('[data-jr-remember-product]').forEach(link => link.addEventListener('click', () => save([{id:link.dataset.jrVariant,handle:link.dataset.jrRememberProduct}])));
  document.querySelectorAll('[data-jr-remember-gift]').forEach(link => link.addEventListener('click', () => {
    save([...link.closest('.jr-native-gift').querySelectorAll('[data-gift-variant]')].map(x => ({id:x.value,handle:x.dataset.productHandle})));
  }));
  const banner = document.querySelector('[data-jr-saved-selection]');
  if (banner && read().length) {
    banner.hidden = false;
    banner.querySelector('[data-jr-discard]').addEventListener('click', () => {clear();banner.hidden=true;});
    const button = banner.querySelector('[data-jr-restore]');
    const status = banner.querySelector('[role=status]');
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled=true;status.textContent='Checking your selection…';
      let attemptedAdd=false;
      try {
        const saved=read();if (!saved.length) {banner.hidden=true;return;}
        const get=async url=>{const r=await fetch(url,{headers:{Accept:'application/json'}});if(!r.ok)throw new Error('read');return r.json();};
        const [cart, ...products]=await Promise.all([get(root+'cart.js'), ...saved.map(x=>get(root+'products/'+x.handle+'.js'))]);
        if (saved.some((x,i)=>!products[i].variants.some(v=>String(v.id)===String(x.id)&&v.available))) {
          status.textContent='Part of this selection is unavailable. Browse the pantry to choose an alternative.';button.disabled=false;return;
        }
        const items=saved.filter(x=>!cart.items.some(i=>String(i.variant_id)===String(x.id))).map(x=>({id:x.id,quantity:1}));
        if(items.length){
          attemptedAdd=true;
          const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const result=await r.json();
          if(!r.ok){status.textContent=typeof result.description==='string'?result.description:'This selection is unavailable. Please check your basket.';button.disabled=false;return;}
        }
        clear();window.location.assign(root+'cart');
      } catch {
        status.replaceChildren(document.createTextNode(attemptedAdd?'We could not confirm the update. ':'We could not check availability. '));
        const link=document.createElement('a');link.href=root+'cart';link.textContent='Check your basket before trying again.';status.append(link);
        if(!attemptedAdd)button.disabled=false;
      }
    });
  }
  const mobile=document.querySelector('[data-jr-mobile-order]');
  const destination=document.querySelector('.jr-member-gate#jr-order-options')||document.querySelector('product-form');
  if(mobile && destination && 'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{mobile.hidden=entries[0].isIntersecting;},{threshold:0});observer.observe(destination);
  }
})();
